export const name = 'ecommerceFactory';
export default function ecommerceFactory($http, $q, $log, pusherChannel, rnPusher) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var vm = this;
  vm.onEcommerceDataChange = null;
  vm.ecommerceCallbackArray = [];
  vm.isNavCallbackInitialized = false;

  let ecommerceBaseUrl = "/api/composer-service/v1/composer/ecommerce";
  let isEcommerceInfoPusherInitialized = false;


  let theFactoryObj = {
    createEcommerceTracking: createEcommerceTracking,
    getEcommerceData: getEcommerceData
  };


  return theFactoryObj;


  function createEcommerceTracking(_onEcommerceDataChange){
    let functionName = "ecommerceFactory.createEcommerceTracking";
    $log.log(angular.toJson({functionName:functionName, action:'function called'}));

    if(_onEcommerceDataChange === undefined || _onEcommerceDataChange === null){

      $log.error(angular.toJson({functionName:functionName, error:'error - expected callback at creation'}));
      return null;
    }else{
      //Remove previous callback function
      //vm.ecommerceCallbackArray = vm.ecommerceCallbackArray.filter(curr => curr.name === 'ecommerceNavCallback');
      if(_onEcommerceDataChange.name === 'ecommerceNavCallback' && vm.isNavCallbackInitialized === false){
        vm.ecommerceCallbackArray.push(_onEcommerceDataChange);
        vm.isNavCallbackInitialized = true;
      }else {
        vm.ecommerceCallbackArray.push(_onEcommerceDataChange);
      }
      ecommerceTracking();
    }
  }

  function ecommerceTracking(){

    if(vm.ecommerceCallbackArray.length === 1 && isEcommerceInfoPusherInitialized === false) {
      initialize();
      isEcommerceInfoPusherInitialized = true;
    }else{
      broadcastEcommerceCount();
    }

    function initialize(){
      let functionName = "EcommerceTracking.initialize";
      $log.log(angular.toJson({functionName:functionName, action:'initializing'}));
      pusherChannel.getChannelName().then(
        function(channelName){

          rnPusher.bind(channelName, "COMPOSER_ECOMMERCE_PACKAGE_CHANGE", function(ecommerceCount){
            if(vm.ecommerceCallbackArray.length > 0){
              //ecommerceCount.count = 950432;
              for(let iCallback in vm.ecommerceCallbackArray){
                vm.ecommerceCallbackArray[iCallback](ecommerceCount);
              }
            }
          });

          // this get triggers backend check if information is updated
          broadcastEcommerceCount();
        },
        function(status){
          $log.error(angular.toJson({functionName:functionName, error:'initializing failed while trying to get pusher channel name', status:status}));
        }
      );
    }

    function broadcastEcommerceCount(){
      let functionName = "EcommerceTracking.broadcastEcommerceCount";
      $log.log(angular.toJson({functionName:functionName, action:'function called'}));
      // this get triggers backend check if information is updated
      getEcommerceData().then(function(ecommerceCount){
        //ecommerceCount.count = 950432;
        if(vm.ecommerceCallbackArray.length > 0){
          $log.log(angular.toJson({functionName:functionName, action:'initialize success', ecommerceCount:ecommerceCount}));
          for(let iCallback in vm.ecommerceCallbackArray){
            vm.ecommerceCallbackArray[iCallback](ecommerceCount);
          }
        }
      }, function(status){
        $log.error(angular.toJson({functionName:functionName, error:'initializing failed while trying to get ecommerce ingo', status:status}));
      });
    }
  }

  function getEcommerceData(){
    let functionName = "EcommerceTracking.getEcommerceData";
    $log.log(angular.toJson({functionName:functionName, action:'function called'}));
    let defer = $q.defer();

    let url = ecommerceBaseUrl + "/org-count";

    $http({method: 'GET', url: url, headers: {'Accept':'application/json'}})
      .then(function(ecommerceCount){
        $log.log(angular.toJson({functionName:functionName, action:'successfully received ecommerce Info', ecommerceCount:ecommerceCount.data}));
        defer.resolve(ecommerceCount.data);
      },function(error){
        $log.log(angular.toJson({functionName:functionName, action:'failed to received ecommerce Info', status:error.status}));
        defer.reject(error.status);
      });

    return defer.promise;
  }
}
